import { DatePicker, Input, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { fetchIssuers } from '../../../store/slices/issuer-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const IssuerForm = () => {
    const [issuerName, setIssuerName] = useState('');
    const [issuerShortName, setIssuerShortName] = useState('');
    const [issuerDate, setIssuerDate] = useState({
        dateValue: '',
        dateString: '',
    });
    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: issuers } = useSelector((state) => state.issuer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchIssuers());
    }, []);

    useEffect(() => {
        console.log(MODE);
        if(MODE === 'EDIT' && issuers.length) {
            const ID = searchParams.get('id');
            const selectedIssuer = issuers.filter((item) => item.issuer_id === ID);
            setIssuerName(selectedIssuer[0].issuer_name);
            setIssuerShortName(selectedIssuer[0].issuer_short_name);
            setIssuerDate({ 
                dateValue: dayjs(selectedIssuer[0].issuer_date.split(' ')[0]), 
                dateString: selectedIssuer[0].issuer_date.split(' ')[0] 
            });
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, issuers]);


    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'issuer_name': issuerName,
            'issuer_short_name': issuerShortName,
            'issuer_date': issuerDate.dateString,
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.issuer_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/issuer/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/issuer-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }  
    }
    const resetHandler = () => {
        setIssuerName('');
        setIssuerShortName('');
        setIssuerDate('');
    }

    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Issuer</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Issuer Name:</label>
                    <Input 
                        onChange={(e) => setIssuerName(e.target.value)} 
                        value={issuerName}
                        size='large' 
                        placeholder='Issuer Name'
                    />
                </div>
                <div className='control'>
                    <label>Issuer Short Name:</label>
                    <Input 
                        onChange={(e) => setIssuerShortName(e.target.value)} 
                        value={issuerShortName}
                        size='large' 
                        placeholder='Issuer Short Name'
                    />
                </div>
                <div className='control'>
                <label>Issuer Date:</label>
                    <div style={{width: '100%'}}>
                        <DatePicker 
                            onChange={(date, dateString) => setIssuerDate({dateValue: date, dateString: dateString})} 
                            value={issuerDate.dateValue}
                            size='large' 
                            style={{width: '100%', borderRadius: '0.2rem'}} 
                        />
                    </div>
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default IssuerForm;


